'use strict';

var React = require('react');

var SvgSunIcon = function SvgSunIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 2a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.25 10a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Zm3.75-2.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 15.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Zm-8.75-6a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm13.75-.75a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Zm-11.23-4.834a.75.75 0 0 1 1.061 0l1.06 1.061a.75.75 0 0 1-1.06 1.06l-1.06-1.06a.75.75 0 0 1 0-1.06Zm10.253 9.193a.75.75 0 1 0-1.061 1.06l1.06 1.061a.75.75 0 0 0 1.061-1.06l-1.06-1.061Zm-10.606 2.121a.75.75 0 0 1 0-1.06l1.06-1.061a.75.75 0 1 1 1.061 1.06l-1.06 1.06a.75.75 0 0 1-1.061 0Zm9.191-10.253a.75.75 0 0 0 1.061 1.06l1.06-1.06a.75.75 0 1 0-1.06-1.06l-1.06 1.06Z"
  }));
};
SvgSunIcon.displayName = "SunIcon";

exports.SvgSunIcon = SvgSunIcon;
